import { sendPostMessage, isApplicationEmbeded } from 'utils';

const { REACT_APP_ENV } = process.env;

export default (error, notifyErrorInProduction = false) => {
  const isOnDevelopment = REACT_APP_ENV === 'dev' || REACT_APP_ENV === 'stg';

  const shouldNotify = notifyErrorInProduction || isOnDevelopment;
  if (shouldNotify) {
    if (isApplicationEmbeded()) {
      const errorMsg = typeof error !== 'string' ? error.message : error;
      sendPostMessage('applicationError', errorMsg);
    } else {
      // eslint-disable-next-line no-console
      console.error('errorHandler:', error);
    }
  }
};
